import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=448616c4&scoped=true"
import script from "./PaginationComponent.ts?vue&type=script&lang=ts&external"
export * from "./PaginationComponent.ts?vue&type=script&lang=ts&external"
import style0 from "./PaginationComponent.scss?vue&type=style&index=0&id=448616c4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448616c4",
  null
  
)

export default component.exports